<template>
  <a-sub-menu v-if="item.children && item.children.length" v-bind="$props" v-on="$listeners">
    <span slot="title"><dy-icon :type="item.icon"></dy-icon>{{item.title}}</span>
    <sidebar-items :item="value" v-for="value in item.children" :key="value.url || value.name"></sidebar-items>
  </a-sub-menu>
  <a-menu-item v-else v-bind="$props" v-on="$listeners"><dy-icon :type="item.icon" v-if="item.icon"></dy-icon>{{item.title}}</a-menu-item>
</template>

<script>
  import {
    Menu
  } from 'ant-design-vue';

  export default {
    name: 'SidebarItems',
    props: {
      ...Menu.SubMenu.props,
      item: {
        type: Object,
        default: null
      },
    }
  }
</script>

<style lang="less" scoped>

</style>